// Row density is a per-device display preference: 'comfortable' (touch-sized rows) or 'compact'.
// It lives on <html data-density>, and index.css shortens ruled rows on wider screens when compact.
const KEY = 'mind_density';

export const getDensity = () => {
  try {
    return localStorage.getItem(KEY) === 'compact' ? 'compact' : 'comfortable';
  } catch {
    return 'comfortable';
  }
};

export const applyDensity = (density = getDensity()) => {
  document.documentElement.setAttribute('data-density', density);
};

export const setDensity = (density) => {
  try {
    localStorage.setItem(KEY, density);
  } catch {
    // Private mode: still apply for this session
  }
  applyDensity(density);
};
